import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image,Card } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom";
// import logo from "./imeges/logo1.png";
// import { Nav, Navbar } from "react-bootstrap";
import Footer from "./Footer";
import { useTheme } from "./ThemeContext";
import NavBar from "./NavBar";
import bgimage from '../src/DetailsProduct/imeages/bgimage.jpg'

  //  icon
  import {FaServer,FaDatabase,FaLaptopCode,FaMobileScreenButton, FaUserDoctor,FaPlus, FaCircleDollarToSlot,FaComputer} from 'react-icons/fa6'
import { FaSearch,FaProjectDiagram } from "react-icons/fa";
import { TbDeviceDesktopAnalytics } from "react-icons/tb";
import { MdMedicalInformation } from "react-icons/md";

// models images
import salary from './DetailsProduct/imeages/salary.png'
import target from './DetailsProduct/imeages/target.png'
import control from './DetailsProduct/imeages/access-control.png'
import scalable from './DetailsProduct/imeages/scalability.png'
import security from './DetailsProduct/imeages/password.png'
import client from './DetailsProduct/imeages/public-relation.png'
const ProductDetail = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const [expandedDesc, setExpandedDesc] = useState("Loading description...");
  // const navigate = useNavigate();
  const { theme } = useTheme();

  useEffect(() => {
    // const basePath = window.location.pathname.split('/').slice(0, 2).join('/'); 
    fetch('/products.json')
          .then((response) => {
        console.log("Response status:", response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log(data)
       
        console.log("Fetched Data:", data);
        const productDetail = data.find((item) => item.id === parseInt(id));
        if (productDetail) {
          setExpandedDesc(productDetail.expandedDesc);
        } else {
          setExpandedDesc("No additional details available.");
        }
      })
      .catch((error) => {
        console.error("Error fetching product details:", error);
        setExpandedDesc("Failed to load details.");
      });
  }, [id]);

  if (!state || !state.product) {
    return <p className="text-center">Product not found</p>;
  }

  const { title, image } = state.product;

   const models = [
       { icon: salary, title: "Improve your Revenue ", desc: "Manage Multiple Rate Cards, Business Promotions, Invoicing, Vendor Payments, Discounts with complete control and with flexibility to meet business objective " },
       { 
         icon: target,
         title: "100% clinically Accurate Report", 
         desc:"Our in-built workflow-based system ensures the right task is performed at the right time and accurate results are produced everytime ",
       },
       { icon: control , 
       title: "Complete Control of Lab Operations", 
       desc: "Manage your lab operations right from Patient Registration to Results Dispatch and all the process in between with ease"
        },
       { icon:client, title: "Empower your Clients and serve your patients  ", desc:"Seamless control of Clients and management allows you to serve your end customers with accurate reports at the same time of providing business flexibility "
       },
       { icon:security, 
       title: "Data Security and Patient Privacy", desc:"We take Patient's Data and its security seriously and ensure the data is secure and privacy is protected "
   
        },
       { icon:scalable , title: "Scalable Architecture ", desc: "Expand your business and focus on growth. Our Flexible Architecture takes care of your future IT needs"
       }
     ];
     const modules = [
       {
         title: <FaMobileScreenButton size={50} style={{ opacity: 0.7 }} />,
         subTittle:"Mobile Apps",
         items: [
           "Custom Built Mobile Apps for Customers",
           "Publishing of API for Customers to build their own Mobile Apps",
           "Mobile Apps built for Android & iOS eco System",
           "Mobile Apps for Pathologists, monitoring your home collections",
         ],
       },
       {
         title: <TbDeviceDesktopAnalytics size={50} style={{ opacity: 0.7 }}/>,
               subTittle:"Analytics",
   
         items: [
           "Advanced Analytics giving in-depth insights into Revenue, Operational & Clinical aspects",
           "Flexibility to communicate to any other system to fetch data for supplementing information-ETL",
           "Data based Decision Making at each & every step",
           "Hosted in Microsoft Environment, Analytics platform built in Power BI",
         ],
       },
       {
         title: <FaUserDoctor size={50} style={{ opacity: 0.7 }}/>,
                     subTittle:"OPD Module",
   
         items: [
           "Comprehensive Suite for Doctors from registration to managing patient case sheets and all the steps in between",
           " Tailor made templates depending on the speciality( for ex:- Dermatologists can have a separate template and general physicians can have their own template)",
           "Seamless Integration with LIS & Inventory"
         ],
       },
     ];
     
     const sections = [
       {
         title: <FaLaptopCode size={50} style={{ opacity: 0.7 }} />,
                     subTittle:"Frontend",
   
         items: [
           "Web API, .Net Core MVC",
           "Improved Performance of Application,Scalable & Robust"
         ]
       },
       {
         title: <FaComputer size={50} style={{ opacity: 0.7 }}/>,
                     subTittle:"Server Side",
   
         items: [
           "SQL-Scalable and Elastic Infrastructure.In built Features for enhanced datasecurity ",
           " Depending on the customer preference,we provide flexibility to choose between SQL/MY SQL/Postgreg",
           "On a case to case basis we offer ORACLEDB assistance at additional cost"
         ]
       },
       {
         title: <FaDatabase size={50} style={{ opacity: 0.7 }}/>,
                     subTittle:"BackEnd",
   
         items: [
           "Comprehensive Suite for Doctors",
           "Tailor-made templates for specialities",
           "Seamless Integration with LIS & Inventory"
         ]
       }
     ];
  return (
    
          <div style={{
        backgroundColor: theme === "dark" ? "#1e1e1e" : "",
        minHeight: "100vh", marginTop:'40px'
      }}>

       <NavBar 
       
       
       
       
       />

      {/* Product Details Section */}
      <Container
        fluid
        className="mt-4 pt-5 "
        // style={{
        //   backgroundColor: theme === "dark" ? "#1e1e1e" : "",
        //   minHeight: "100vh",
        // }}
        //  style={{
        //       // backgroundImage:`url(${bgimage})`,
        //       backgroundImage: theme === "light" ? "" : "none",
        //       backgroundColor: theme === "dark" ? "#1e1e1e" : "none",
        //       backgroundSize: 'cover', 
        //       backgroundPosition: 'center',
        //       backgroundRepeat: 'no-repeat',
        //     }}
      >
        <Row className="align-items-center justify-content-center ms-5 mb-3">
          {/* Left Side - Image */}
          

          {/* Right Side - Title & Description */}
          <Col xs={12} md={8} className="text-md-start text-center">
            <h2 className="fw-bold text-capitalize text-decoration-underline text-sm-center">{title}</h2>
            <p className="mt-3 text-sm-center" style={{ fontSize: "18px", lineHeight: "1.6" }}>
              {expandedDesc}
            </p>
          </Col>

          <Col xs={12} md={4} className="text-center align-items-start">
            <Image
              src={image}
              loading="lazy"
              
              className=" rounded-circle img-fluid mx-auto d-block"                         

              style={{
                width:"400px",height:"400px",
                 objectFit: "cover",

              }}
            />
          </Col>
        </Row>
      
     



     <Container className=" ">
        {/* <h4 className='text-center text-primary'>HIGH LEVEL MODELS </h4> */}
        <Row className="justify-content-center">
        {models.map((model, index) => (
          <Col md={4} sm={12} key={index} className="">  
                         
                                    {/* borderTopLeftRadius:'50px',borderBottomLeftRadius:'50px', */}
            <Card className="d-flex align-items-center  p-3 mb-3 "style={{minHeight:'300px'}}>
              {/* <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center" style={{fontSize: "1.5rem" }}>
              
              </div> */}
               <div className='d-flex align-items-center justify-content-center mb-3'>
                                  <img src={model.icon} alt={model.title} height={80} width={80} />

                          </div>
              <div className="ms-3">
                <h5 className="mb-1">{model.title}</h5>
                {/* <p className="mb-0 text-muted">{model.desc}</p> */}
                <ul className='list-unstyled'>
                 
                       <li > {model.desc}</li>
                  
                
                </ul>
              </div>
            </Card>
          </Col>
        ))}
      </Row>

  </Container>

  <Container fluid className="py-3">
      <h2 className="text-primary text-center mt-3 ">Add On Modules</h2>
      <Row className="justify-content-center">
        {modules.map((module, index) => (
          <Col md={4} sm={12} key={index} className="mb-4">
            <Card className="shadow-sm border-0 "  style={{minHeight:'380px'}}>
              <Card.Header className=" text-dark text-center fw-bold fs-5">
                {module.title}
                
              </Card.Header>
              {/* <p className='fw-bold fs-4 ms-4'>Mobile APPS</p> */}
              <h5 className='fw-bold mt-3 ms-4'>{module.subTittle}</h5>
              <Card.Body>
                <ul className="list-unstyled">
                  {module.items.map((item, idx) => (
                    <li key={idx} className=" lh-3" >➤ {item}</li>
                  ))}
                </ul>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>

     <Container fluid >
              <h2 className='text-primary text-pperase text-center '>TECHNOLOGY STACK </h2>
              
              <Row className="justify-content-center">
              {sections.map((section,index)=>(
                 <Col md={4} xs={12} key={index}  className='mb-2'  >
                    <Card className='shadow-sm border-0' style={{minHeight:'330px'}}>
                      <Card.Header className='  text-center '>
                        {section.title}
                        
                      </Card.Header>
                         <h5 className='fw-bold mt-3 ms-4'>{section.subTittle}</h5>

                      <Card.Body>
                        <ul className='list-unstyled'>
                          {section.items.map((item,idx)=>(
                            <li key={idx} className='lh-3'>➤ {item}</li>
                          ))}
                        </ul>
                      </Card.Body>
                    </Card>

                 </Col>
              ))}

                

              </Row>

     </Container>
     </Container>
      <Footer />
    </div>
  );
};

export default ProductDetail;
